import { render, staticRenderFns } from "./Car.vue?vue&type=template&id=6cccb5ba&scoped=true"
import script from "./Car.vue?vue&type=script&lang=js"
export * from "./Car.vue?vue&type=script&lang=js"
import style0 from "./Car.vue?vue&type=style&index=0&id=6cccb5ba&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6cccb5ba",
  null
  
)

export default component.exports